import { memo } from 'react';

import ExcelIcon from '@/assets/excel-icon.svg?react';
import { Logo, LogoProps } from '@/components/core';

export type ExcelLogoProps = LogoProps;

const IExcelLogo = ({ className, ...rest }: ExcelLogoProps) => {
  return (
    <Logo className={className} {...rest}>
      <ExcelIcon />
    </Logo>
  );
};

export const ExcelLogo = memo(IExcelLogo) as typeof IExcelLogo;
